/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import {
    BrandingUiBundle,
    Configuration,
    ConfigurationParameters,
    MsoDefaultBrandingUiBundleApi,
    MsoDefaultBrandingUiBundleRequest,
} from 'client-code/branding-ui-bundle';
import { CommonHeaders } from '../CommonHeaders';
import { Constants } from '../constants';
import { DeviceModel } from '../device/DeviceModel';
import { IMsoDefaultBrandingUiBundleServiceRepository } from '../interfaces/IMsoDefaultBrandingUiBundleServiceRepository';
import { Log } from '../logging/Log';
import { UniqueIdentifier } from '../utils/UniqueIdentifier';
import { APPLICATION_FEATURE_AREA } from '../../config';

export class MsoDefaultBrandingUiBundleServiceRepositoryImpl
    implements IMsoDefaultBrandingUiBundleServiceRepository
{
    private commonHeaders;

    private msoDefaultBrandingApi;

    private static baseUrl: string;

    private static brandingUiResponse: BrandingUiBundle = {};

    TAG: string = 'MsoDefaultBrandingUiBundleServiceRepositoryImpl';

    constructor() {
        this.commonHeaders = new CommonHeaders(APPLICATION_FEATURE_AREA.STARTUP).headers;
        const configurationParameters: ConfigurationParameters = {
            basePath: MsoDefaultBrandingUiBundleServiceRepositoryImpl.baseUrl,
            baseOptions: {
                timeout: Constants.SERVICE_CONNECTION_TIMEOUT,
                headers: this.commonHeaders,
            },
        };
        const configuration = new Configuration(configurationParameters);
        this.msoDefaultBrandingApi = new MsoDefaultBrandingUiBundleApi(configuration);
    }

    static initialize(baseUrl: string) {
        MsoDefaultBrandingUiBundleServiceRepositoryImpl.baseUrl = baseUrl;
    }

    private async fetchBrandingUiInfo(): Promise<void> {
        try {
            const requestParameters: MsoDefaultBrandingUiBundleRequest = {
                msoName: DeviceModel.getTiVoSettings().getMsoName(),
                slsDomain: DeviceModel.getTiVoSettings().getSlsDomain(),
                applicationFeatureArea: this.commonHeaders.ApplicationFeatureArea,
                applicationName: DeviceModel.getTiVoSettings().getAppName(),
                applicationVersion: DeviceModel.getAppVersionName(),
                deviceType: DeviceModel.getTiVoSettings().getDeviceType(),
                productName: DeviceModel.getTiVoSettings().getAppName(),
                originRequestId: UniqueIdentifier.generateOriginRequestId(),
            };

            const apiResponse = await this.msoDefaultBrandingApi.msoDefaultBrandingUiBundle(
                requestParameters,
            );
            MsoDefaultBrandingUiBundleServiceRepositoryImpl.brandingUiResponse = apiResponse.data;
        } catch (error) {
            Log.e(this.TAG, 'getBrandingUiInfo', error);
            throw error;
        }
    }

    getBrandingUiInfoForKey(key: string): any {
        Log.d(this.TAG, `returning brandingUiInfo for ${key}`);
        if (MsoDefaultBrandingUiBundleServiceRepositoryImpl.brandingUiResponse[key])
            return MsoDefaultBrandingUiBundleServiceRepositoryImpl.brandingUiResponse[key];
        throw new Error(`BrandingAssetNotFoundError for '${key}'.`);
    }

    async fetchMsoDefaultBrandingUiInfo(): Promise<void> {
        try {
            await this.fetchBrandingUiInfo();
        } catch (error) {
            Log.e(this.TAG, 'getMsoDefaultBrandingUiInfo', error);
            throw error;
        }
    }
}
